import type { ReactNode } from "react";

export type GameIconType = "exit" | "back" | "heart" | "check" | "send" | "sort" | "chat" | "skip";

/** In-game line/solid icons ported from the Bing card-room design's `gicon`
 * set (stroke = currentColor, so they inherit the button's color). */
export function GameIcon({ type, size = 18 }: { type: GameIconType; size?: number }): ReactNode {
  const fill = type === "heart" || type === "skip";
  const common = {
    viewBox: "0 0 24 24",
    width: size,
    height: size,
    fill: fill ? "currentColor" : "none",
    stroke: fill ? "none" : "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    style: { display: "block" as const },
  };
  const paths: Record<GameIconType, string[]> = {
    exit: ["M14 4H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7", "M18 15l3-3-3-3", "M21 12H10"],
    back: ["M9 5l7 7-7 7"],
    heart: ["M12 20s-6.5-4.3-6.5-9A3.5 3.5 0 0 1 12 8a3.5 3.5 0 0 1 6.5 3c0 4.7-6.5 9-6.5 9z"],
    check: ["M5 12l4.5 4.5L19 7"],
    send: ["M22 2 11 13", "M22 2 15 22l-4-9-9-4 20-7z"],
    sort: ["M4 7h16", "M7 12h10", "M10 17h4"],
    chat: ["M21 12a8 8 0 0 1-11.5 7.2L4 20l1-4.8A8 8 0 1 1 21 12z"],
    skip: ["M5 5l7 7-7 7z", "M13 5l7 7-7 7z"],
  };
  return (
    <svg {...common} aria-hidden="true">
      {paths[type].map((d, i) => (
        <path key={i} d={d} />
      ))}
    </svg>
  );
}
